/* MSW Wishlist — appless, replaces Wishlist Plus (Swym).
 * Shared contract: localStorage "msw_wishlist" = array of product handle strings.
 * API on window.MSWWish: toggle(handle) -> bool nowInList, has(handle), list(), count().
 * Dispatches 'msw-wish:change' on document after every mutation.
 * UI hooks: [data-msw-wish-count] badges, [data-msw-wish-toggle="<handle>"] buttons
 * (delegated, survive section re-render; active state = .is-wished + aria-pressed,
 * aria-label swapped from data-label-add / data-label-remove).
 * Storage is per-device (no backend) — cross-device sync would need an app proxy
 * like GG's; documented tradeoff of dropping Wishlist Plus.
 * Loaded once, deferred, from layout/theme.liquid.
 */
(function () {
  'use strict';

  var KEY = 'msw_wishlist';

  function read() {
    try {
      var handles = JSON.parse(localStorage.getItem(KEY));
      if (!Array.isArray(handles)) return [];
      var seen = {};
      return handles.filter(function (h) {
        if (typeof h !== 'string' || !h || seen[h]) return false;
        seen[h] = true;
        return true;
      });
    } catch (e) {
      return [];
    }
  }

  function write(handles) {
    try {
      localStorage.setItem(KEY, JSON.stringify(handles));
    } catch (e) {
      /* storage blocked/full: wishlist lives only for this page */
    }
    document.dispatchEvent(new CustomEvent('msw-wish:change', { detail: { handles: handles } }));
  }

  var MSWWish = {
    list: function () {
      return read();
    },
    count: function () {
      return read().length;
    },
    has: function (handle) {
      return read().indexOf(handle) !== -1;
    },
    toggle: function (handle) {
      if (!handle) return false;
      var handles = read();
      var i = handles.indexOf(handle);
      var nowInList;
      if (i === -1) {
        handles.push(handle);
        nowInList = true;
      } else {
        handles.splice(i, 1);
        nowInList = false;
      }
      write(handles);
      return nowInList;
    }
  };

  window.MSWWish = MSWWish;

  function refresh() {
    var handles = read();
    var n = handles.length;
    document.querySelectorAll('[data-msw-wish-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
    var inList = {};
    handles.forEach(function (h) {
      inList[h] = true;
    });
    document.querySelectorAll('[data-msw-wish-toggle]').forEach(function (btn) {
      var wished = !!inList[btn.getAttribute('data-msw-wish-toggle')];
      btn.classList.toggle('is-wished', wished);
      btn.setAttribute('aria-pressed', wished ? 'true' : 'false');
      var label = wished ? btn.getAttribute('data-label-remove') : btn.getAttribute('data-label-add');
      if (label) btn.setAttribute('aria-label', label);
    });
  }

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;
    /* Header heart: open the drawer when it exists; the href stays as no-JS fallback. */
    if (t.closest('.msw-header-wish') && window.MSWWishDrawer) {
      event.preventDefault();
      window.MSWWishDrawer.open();
      return;
    }
    var btn = t.closest('[data-msw-wish-toggle]');
    if (!btn) return;
    event.preventDefault();
    var nowInList = MSWWish.toggle(btn.getAttribute('data-msw-wish-toggle'));
    /* Open the drawer after an ADD (never on remove), gated by the
       msw_wish_drawer_on_add setting emitted as data-open-on-add. */
    if (nowInList && window.MSWWishDrawer) {
      var drawer = document.querySelector('[data-msw-wish-drawer]');
      if (drawer && drawer.getAttribute('data-open-on-add') === 'true') window.MSWWishDrawer.open();
    }
  });

  document.addEventListener('msw-wish:change', refresh);
  document.addEventListener('shopify:section:load', refresh);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
